import React from 'react'
import './button.css'

const Button = (props) => {
    return (
        <button className="button-element" style={props.isFullWidth ? {width: "100%", backgroundColor: `${props.bgcolor}`} : {backgroundColor: `${props.bgcolor}`, margin: '0px auto'}} onClick={props.onClick}>
            <div className='button-text' style={props.isFullWidth ? {width: "100%"} : undefined}>
                {props.buttonIcon}
                {props.buttonText}
            </div>
        </button>
    )
}

export default Button


// WEBPACK FOOTER //
// ./src/components/Button.js